var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "wrapper",
    [
      _c("template", { slot: "header-actions" }, [
        _c("div", { staticClass: "btn-group" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary dropdown-toggle",
              attrs: {
                type: "button",
                "data-toggle": "dropdown",
                disabled: _vm.isExporting
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.isExporting ? "Exporting" : "Export Data") +
                  " "
              ),
              _vm.isExporting
                ? _c("i", { staticClass: "fa fa-spin fa-spinner ml-2" })
                : _c("span", { staticClass: "caret ml-2" })
            ]
          ),
          _c("ul", { staticClass: "dropdown-menu dropdown-menu-right" }, [
            _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.getSchoolsCSV($event)
                    }
                  }
                },
                [_vm._v("Schools CSV")]
              )
            ]),
            _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.getReadersCSV($event)
                    }
                  }
                },
                [_vm._v("Readers CSV")]
              )
            ])
          ])
        ])
      ]),
      _c(
        "div",
        { staticClass: "challenges-report-page" },
        [
          _c("div", { staticClass: "dashbox-strip" }, [
            _c(
              "div",
              { staticClass: "dashbox-cell" },
              [
                _c(
                  "flip-card",
                  { attrs: { id: "db-readers-in-schools" } },
                  [
                    _c("dash-box", {
                      attrs: {
                        slot: "front",
                        title: "Schools Registered",
                        value: _vm.totalOrgs.total,
                        active_value: _vm.totalOrgs.active
                      },
                      slot: "front"
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "dashbox__help",
                        attrs: { slot: "back" },
                        slot: "back"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.totalOrgs.total.toLocaleString("en"))
                          )
                        ]),
                        _vm._v(" schools have registered, "),
                        _c("i", { staticClass: "fa fa-bolt" }),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.totalOrgs.active.toLocaleString("en"))
                          )
                        ]),
                        _vm._v(" have at least 1 child who has read something.")
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "dashbox-cell" },
              [
                _c(
                  "flip-card",
                  { attrs: { id: "db-readers-in-schools" } },
                  [
                    _c("dash-box", {
                      attrs: {
                        slot: "front",
                        title: "Parents Registered",
                        value: _vm.totalUsers.total,
                        active_value: _vm.totalUsers.active
                      },
                      slot: "front"
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "dashbox__help",
                        attrs: { slot: "back" },
                        slot: "back"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.totalUsers.total.toLocaleString("en"))
                          )
                        ]),
                        _vm._v(" parents have registered, "),
                        _c("i", { staticClass: "fa fa-bolt" }),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.totalUsers.active.toLocaleString("en"))
                          )
                        ]),
                        _vm._v(" have at least 1 child who has read something.")
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "dashbox-cell" },
              [
                _c(
                  "flip-card",
                  { attrs: { id: "db-readers-registered" } },
                  [
                    _c("dash-box", {
                      attrs: {
                        slot: "front",
                        title: "Readers Registered",
                        value: _vm.totalReaders.total,
                        active_value: _vm.totalReaders.active
                      },
                      slot: "front"
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "dashbox__help",
                        attrs: { slot: "back" },
                        slot: "back"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.totalReaders.total.toLocaleString("en"))
                          )
                        ]),
                        _vm._v(" children are in the challenge, "),
                        _c("i", { staticClass: "fa fa-bolt" }),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.totalReaders.active.toLocaleString("en"))
                          )
                        ]),
                        _vm._v(" have read something.")
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "dashbox-cell" },
              [
                _c(
                  "flip-card",
                  { attrs: { id: "db-readers-in-schools" } },
                  [
                    _c("dash-box", {
                      attrs: {
                        slot: "front",
                        title: "Readers Associated to a School",
                        value: _vm.readersInOrgs.total,
                        active_value: _vm.readersInOrgs.active
                      },
                      slot: "front"
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "dashbox__help",
                        attrs: { slot: "back" },
                        slot: "back"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.readersInOrgs.total.toLocaleString("en"))
                          )
                        ]),
                        _vm._v(" children are associated with a school, "),
                        _c("i", { staticClass: "fa fa-bolt" }),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.readersInOrgs.active.toLocaleString("en")
                            )
                          )
                        ]),
                        _vm._v(" have read something.")
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "dashbox-cell" },
              [
                _c(
                  "flip-card",
                  { attrs: { id: "db-readers-not-in-school" } },
                  [
                    _c("dash-box", {
                      attrs: {
                        slot: "front",
                        title: "Readers not in School",
                        value: _vm.readersNotInOrgs.total,
                        active_value: _vm.readersNotInOrgs.active
                      },
                      slot: "front"
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "dashbox__help",
                        attrs: { slot: "back" },
                        slot: "back"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.readersNotInOrgs.total.toLocaleString("en")
                            )
                          )
                        ]),
                        _vm._v(" children are "),
                        _c("strong", [_c("u", [_vm._v("not")])]),
                        _vm._v(" associated with a school, "),
                        _c("i", { staticClass: "fa fa-bolt" }),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.readersNotInOrgs.active.toLocaleString("en")
                            )
                          )
                        ]),
                        _vm._v(" have read something.")
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "h2",
                {
                  staticStyle: {
                    "font-weight": "200",
                    color: "#224450",
                    "text-shadow": "1px 1px 0 #ffffffb3",
                    display: "flex",
                    "align-items": "flex-end"
                  }
                },
                [
                  _vm._v(" Partners "),
                  _c("label", { staticClass: "referred-toggle" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.referredOnly,
                          expression: "referredOnly"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.referredOnly)
                          ? _vm._i(_vm.referredOnly, null) > -1
                          : _vm.referredOnly
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.referredOnly,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.referredOnly = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.referredOnly = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.referredOnly = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" Referred only ")
                  ]),
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-xs btn-link ml-auto",
                      attrs: {
                        to: "/challenges/" + _vm.challenge + "/partners/new"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-plus",
                        staticStyle: {
                          "font-size": "0.9em",
                          "margin-right": "4px"
                        }
                      }),
                      _vm._v("Add Partner ")
                    ]
                  )
                ],
                1
              ),
              _c(
                "table",
                {
                  staticClass:
                    "table table-striped table-hover table-condensed",
                  staticStyle: {
                    background: "white",
                    "box-shadow": "2px 2px 3px 0px #c7d5e6"
                  }
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("Partner")]),
                      _c("th", [_vm._v("Schools")]),
                      _c("th", [_vm._v("Parents")])
                    ])
                  ]),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.partnersByCategory, function(group) {
                        return [
                          _c(
                            "tr",
                            {
                              key: "cat-" + group.category,
                              staticClass: "category-heading",
                              on: {
                                click: function($event) {
                                  return _vm.toggleCategory(group.category)
                                }
                              }
                            },
                            [
                              _c("td", { attrs: { colspan: "3" } }, [
                                _c("i", {
                                  staticClass: "fa",
                                  class: _vm.isCategoryCollapsed(group.category)
                                    ? "fa-caret-right"
                                    : "fa-caret-down"
                                }),
                                _vm._v(" " + _vm._s(group.label) + " "),
                                _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("(" + _vm._s(group.count) + ")")
                                ])
                              ])
                            ]
                          ),
                          _vm._l(
                            _vm.isCategoryCollapsed(group.category)
                              ? []
                              : group.partners,
                            function(p) {
                              return [
                                p.children && p.children.length > 0
                                  ? [
                                      _c(
                                        "tr",
                                        {
                                          key: "heading-" + p.id,
                                          staticClass: "active"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "3" } },
                                            [
                                              _c(
                                                "strong",
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to:
                                                          "/challenges/" +
                                                          _vm.challenge +
                                                          "/partners/" +
                                                          p.slug
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(p.name))]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._l(p.children, function(child) {
                                        return _c(
                                          "tr",
                                          { key: "child-" + child.id },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  "padding-left": "20px"
                                                }
                                              },
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    attrs: {
                                                      to:
                                                        "/challenges/" +
                                                        _vm.challenge +
                                                        "/partners/" +
                                                        child.slug
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(child.name))]
                                                )
                                              ],
                                              1
                                            ),
                                            _c("td", [
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value:
                                                        _vm.linkCount(
                                                          child,
                                                          "organisations"
                                                        ) > 0
                                                          ? "Click to view these schools"
                                                          : "",
                                                      expression:
                                                        "linkCount(child, 'organisations') > 0 ? 'Click to view these schools' : ''"
                                                    }
                                                  ],
                                                  class: {
                                                    "referral-clickable":
                                                      _vm.linkCount(
                                                        child,
                                                        "organisations"
                                                      ) > 0
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      _vm.linkCount(
                                                        child,
                                                        "organisations"
                                                      ) > 0 &&
                                                        _vm.setSchoolFilter({
                                                          type: "partner",
                                                          partnerId: child.id,
                                                          referredOnly:
                                                            _vm.referredOnly,
                                                          label: child.name
                                                        })
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.linkCount(
                                                        child,
                                                        "organisations"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.linkCount(child, "users")
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      })
                                    ]
                                  : _c("tr", { key: p.id }, [
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to:
                                                  "/challenges/" +
                                                  _vm.challenge +
                                                  "/partners/" +
                                                  p.slug
                                              }
                                            },
                                            [_vm._v(_vm._s(p.name))]
                                          )
                                        ],
                                        1
                                      ),
                                      _c("td", [
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value:
                                                  _vm.linkCount(
                                                    p,
                                                    "organisations"
                                                  ) > 0
                                                    ? "Click to view these schools"
                                                    : "",
                                                expression:
                                                  "linkCount(p, 'organisations') > 0 ? 'Click to view these schools' : ''"
                                              }
                                            ],
                                            class: {
                                              "referral-clickable":
                                                _vm.linkCount(
                                                  p,
                                                  "organisations"
                                                ) > 0
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                _vm.linkCount(
                                                  p,
                                                  "organisations"
                                                ) > 0 &&
                                                  _vm.setSchoolFilter({
                                                    type: "partner",
                                                    partnerId: p.id,
                                                    referredOnly:
                                                      _vm.referredOnly,
                                                    label: p.name
                                                  })
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.linkCount(
                                                  p,
                                                  "organisations"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.linkCount(p, "users"))
                                        )
                                      ])
                                    ])
                              ]
                            }
                          )
                        ]
                      }),
                      _vm.partners.length === 0
                        ? _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "text-muted text-center",
                                attrs: { colspan: "3" }
                              },
                              [_vm._v("No partners yet")]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "h2",
                {
                  staticStyle: {
                    "font-weight": "200",
                    color: "#224450",
                    "text-shadow": "1px 1px 0 #ffffffb3",
                    display: "flex",
                    "align-items": "flex-end"
                  }
                },
                [
                  _vm._v(" Non-Partner Referrals "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-xs btn-link ml-auto",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.showLinkBuilder = true
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-link",
                        staticStyle: {
                          "font-size": "0.9em",
                          "margin-right": "4px"
                        }
                      }),
                      _vm._v("Build a tracking link ")
                    ]
                  )
                ]
              ),
              _c(
                "table",
                {
                  staticClass:
                    "table table-striped table-hover table-condensed",
                  staticStyle: {
                    background: "white",
                    "box-shadow": "2px 2px 3px 0px #c7d5e6"
                  }
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("Source / Medium / Content")]),
                      _c("th", { staticStyle: { "text-align": "right" } }, [
                        _vm._v("Schools")
                      ]),
                      _c("th", { staticStyle: { "text-align": "right" } }, [
                        _vm._v("Parents")
                      ])
                    ])
                  ]),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.nonPartnerReferrals, function(source, si) {
                        return [
                          _c(
                            "tr",
                            {
                              key: "src-" + si,
                              staticClass: "referral-source-heading",
                              class: {
                                "referral-muted": _vm.isUnknownLabel(
                                  source.source
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleSource(si)
                                }
                              }
                            },
                            [
                              _c("td", [
                                _c("i", {
                                  staticClass: "fa",
                                  class: _vm.isSourceCollapsed(si)
                                    ? "fa-caret-right"
                                    : "fa-caret-down"
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.sourceLabel(source.source)) +
                                    " "
                                )
                              ]),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value:
                                            source.schools > 0
                                              ? "Click to view these schools"
                                              : "",
                                          expression:
                                            "source.schools > 0 ? 'Click to view these schools' : ''"
                                        }
                                      ],
                                      class: {
                                        "referral-clickable": source.schools > 0
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          source.schools > 0 &&
                                            _vm.setSchoolFilter({
                                              type: "utm",
                                              source: _vm.normaliseUtm(
                                                source.source
                                              )
                                            })
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(source.schools))]
                                  )
                                ]
                              ),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [_vm._v(_vm._s(source.parents))]
                              )
                            ]
                          ),
                          _vm._l(
                            _vm.isSourceCollapsed(si) ? [] : source.mediums,
                            function(medium, mi) {
                              return [
                                _c(
                                  "tr",
                                  {
                                    key: "src-" + si + "-med-" + mi,
                                    staticClass: "referral-medium-row",
                                    class: {
                                      "referral-medium-clickable":
                                        medium.contents &&
                                        medium.contents.length > 0,
                                      "referral-muted": _vm.isUnknownLabel(
                                        medium.medium
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        medium.contents &&
                                        medium.contents.length > 0
                                          ? _vm.toggleMedium(si, mi)
                                          : null
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "td",
                                      {
                                        staticStyle: { "padding-left": "20px" }
                                      },
                                      [
                                        medium.contents &&
                                        medium.contents.length > 0
                                          ? _c("i", {
                                              staticClass: "fa",
                                              class: _vm.isMediumCollapsed(
                                                si,
                                                mi
                                              )
                                                ? "fa-caret-right"
                                                : "fa-caret-down"
                                            })
                                          : _c("span", {
                                              staticClass:
                                                "referral-caret-spacer"
                                            }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              medium.medium || "Unknown medium"
                                            ) +
                                            " "
                                        ),
                                        _vm.isDirtyLabel(medium.medium)
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "text-muted",
                                                staticStyle: {
                                                  "font-size": "0.85em"
                                                },
                                                attrs: {
                                                  title:
                                                    "from a malformed tracking link"
                                                }
                                              },
                                              [_vm._v("(malformed link)")]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: { "text-align": "right" }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value:
                                                  medium.schools > 0
                                                    ? "Click to view these schools"
                                                    : "",
                                                expression:
                                                  "medium.schools > 0 ? 'Click to view these schools' : ''"
                                              }
                                            ],
                                            class: {
                                              "referral-clickable":
                                                medium.schools > 0
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                medium.schools > 0 &&
                                                  _vm.setSchoolFilter({
                                                    type: "utm",
                                                    source: _vm.normaliseUtm(
                                                      source.source
                                                    ),
                                                    medium: _vm.normaliseUtm(
                                                      medium.medium
                                                    )
                                                  })
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(medium.schools))]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: { "text-align": "right" }
                                      },
                                      [_vm._v(_vm._s(medium.parents))]
                                    )
                                  ]
                                ),
                                _vm._l(
                                  _vm.isMediumCollapsed(si, mi)
                                    ? []
                                    : medium.contents,
                                  function(content, ci) {
                                    return _c(
                                      "tr",
                                      {
                                        key:
                                          "src-" +
                                          si +
                                          "-med-" +
                                          mi +
                                          "-con-" +
                                          ci,
                                        staticClass: "referral-content-row",
                                        class: {
                                          "referral-muted":
                                            content.content === null ||
                                            _vm.isUnknownLabel(content.content)
                                        }
                                      },
                                      [
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              "padding-left": "40px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  content.content === null
                                                    ? "No specific content"
                                                    : content.content
                                                ) +
                                                " "
                                            ),
                                            _vm.isDirtyLabel(content.content)
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-muted",
                                                    staticStyle: {
                                                      "font-size": "0.85em"
                                                    },
                                                    attrs: {
                                                      title:
                                                        "from a malformed tracking link"
                                                    }
                                                  },
                                                  [_vm._v("(malformed link)")]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              "text-align": "right"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                    value:
                                                      content.schools > 0
                                                        ? "Click to view these schools"
                                                        : "",
                                                    expression:
                                                      "content.schools > 0 ? 'Click to view these schools' : ''"
                                                  }
                                                ],
                                                class: {
                                                  "referral-clickable":
                                                    content.schools > 0
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    content.schools > 0 &&
                                                      _vm.setSchoolFilter({
                                                        type: "utm",
                                                        source: _vm.normaliseUtm(
                                                          source.source
                                                        ),
                                                        medium: _vm.normaliseUtm(
                                                          medium.medium
                                                        ),
                                                        content: _vm.normaliseUtm(
                                                          content.content
                                                        ),
                                                        contentIsRemainder:
                                                          content.content ===
                                                          null
                                                      })
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(content.schools))]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              "text-align": "right"
                                            }
                                          },
                                          [_vm._v(_vm._s(content.parents))]
                                        )
                                      ]
                                    )
                                  }
                                )
                              ]
                            }
                          )
                        ]
                      }),
                      _vm.nonPartnerReferrals.length === 0
                        ? _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "text-muted text-center",
                                attrs: { colspan: "3" }
                              },
                              [_vm._v("No non-partner referrals yet")]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ]
              ),
              _c("div", [
                _c(
                  "h2",
                  {
                    staticStyle: {
                      "font-weight": "200",
                      color: "#224450",
                      "text-shadow": "1px 1px 0 #ffffffb3",
                      "margin-top": "30px"
                    }
                  },
                  [_vm._v("Regional Breakdown")]
                ),
                _c(
                  "table",
                  {
                    staticClass:
                      "table table-striped table-hover table-condensed",
                    staticStyle: {
                      background: "white",
                      "box-shadow": "2px 2px 3px 0px #c7d5e6"
                    }
                  },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Region")]),
                        _c("th", [_vm._v("Schools")]),
                        _c("th", [_vm._v("Parents")]),
                        _c("th", [_vm._v("Readers")])
                      ])
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.regions, function(r, i) {
                        return _c("tr", { key: i }, [
                          _c("td", [_vm._v(_vm._s(r || "Unknown Region"))]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value:
                                      (_vm.regionSchoolCounts[r] || 0) > 0
                                        ? "Click to view these schools"
                                        : "",
                                    expression:
                                      "(regionSchoolCounts[r] || 0) > 0 ? 'Click to view these schools' : ''"
                                  }
                                ],
                                class: {
                                  "referral-clickable":
                                    (_vm.regionSchoolCounts[r] || 0) > 0
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    ;(_vm.regionSchoolCounts[r] || 0) > 0 &&
                                      _vm.setSchoolFilter({
                                        type: "region",
                                        region: r,
                                        label: r || "Unknown Region"
                                      })
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.regionSchoolCounts[r] || 0))]
                            )
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.totalUsers.regional[r]
                                  ? _vm.totalUsers.regional[r].total
                                  : 0
                              )
                            )
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.totalReaders.regional[r]
                                  ? _vm.totalReaders.regional[r].total
                                  : 0
                              )
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ]
                )
              ]),
              _c("div", [
                _c(
                  "h2",
                  {
                    staticStyle: {
                      "font-weight": "200",
                      color: "#224450",
                      "text-shadow": "1px 1px 0 #ffffffb3"
                    }
                  },
                  [_vm._v("Certificates & Stars")]
                ),
                _c(
                  "table",
                  {
                    staticClass:
                      "table table-striped table-hover table-condensed",
                    staticStyle: {
                      background: "white",
                      "box-shadow": "2px 2px 3px 0px #c7d5e6"
                    }
                  },
                  [
                    _c("thead", [
                      _c("tr", [_c("th"), _c("th", [_vm._v("Awarded")])])
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.certificates, function(c, i) {
                        return _c("tr", { key: i }, [
                          _c(
                            "td",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: {
                                    content: c.description,
                                    placement: "auto-start"
                                  },
                                  expression:
                                    "{content:c.description, placement: 'auto-start'}"
                                }
                              ]
                            },
                            [_vm._v(_vm._s(c.name))]
                          ),
                          _c("td", [_vm._v(_vm._s(c.count))])
                        ])
                      }),
                      0
                    )
                  ]
                )
              ])
            ])
          ]),
          _c("div", { ref: "schoolsTable", staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "report-header" }, [
                _c(
                  "h2",
                  {
                    staticStyle: {
                      "font-weight": "200",
                      color: "#224450",
                      "text-shadow": "1px 1px 0 #ffffffb3"
                    }
                  },
                  [_vm._v("Schools")]
                )
              ]),
              _vm.schoolFilter
                ? _c("div", { staticClass: "school-filter-banner" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.schoolFilter.type === "region"
                            ? "Showing schools in"
                            : "Showing schools referred by"
                        ) + " "
                      ),
                      _c("strong", [_vm._v(_vm._s(_vm.schoolFilter.label))])
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-xs btn-link",
                        attrs: { type: "button" },
                        on: { click: _vm.clearSchoolFilter }
                      },
                      [_vm._v("Clear filter")]
                    )
                  ])
                : _vm._e()
            ]),
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("vue-good-table", {
                  ref: "schoolsGrid",
                  attrs: {
                    styleClass: "vgt-table striped",
                    theme: "auris-admin",
                    columns: _vm.columns,
                    rows: _vm.filteredSchools,
                    totalRows: _vm.filteredSchools.length,
                    "pagination-options": {
                      enabled: true,
                      mode: "records",
                      perPage: 25,
                      position: "bottom",
                      perPageDropdown: [10, 25, 50, 100],
                      dropdownAllowAll: false,
                      setCurrentPage: 1,
                      nextLabel: "next",
                      prevLabel: "prev",
                      rowsPerPageLabel: "Rows per page",
                      ofLabel: "of",
                      pageLabel: "page", // for 'pages' mode
                      allLabel: "All"
                    },
                    "search-options": {
                      enabled: true,
                      placeholder: "Search this table"
                    },
                    "sort-options": {
                      enabled: true,
                      initialSortBy: { field: "name", type: "asc" }
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "table-row",
                      fn: function(props) {
                        return [
                          props.column.field == "name"
                            ? _c("span", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        "/challenges/" +
                                        _vm.challenge +
                                        "/organisations/" +
                                        props.row.id
                                    }
                                  },
                                  [_vm._v(_vm._s(props.row.name))]
                                )
                              ])
                            : props.column.field === "rank"
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      props.row.rank === null
                                        ? "-"
                                        : _vm.numberRank(props.row.rank)
                                    ) +
                                    " "
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      props.formattedRow[props.column.field]
                                    ) +
                                    " "
                                )
                              ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ]),
          _vm.showLinkBuilder
            ? _c("utm-link-builder", {
                attrs: {
                  "challenge-slug": _vm.challenge,
                  domain: _vm.challengeDomain
                },
                on: {
                  close: function($event) {
                    _vm.showLinkBuilder = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }